import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row } from "reactstrap";
import { OperatorDataCard } from "./components";
import Loader from "components/Loader";
import { setSelectedOp } from "containers/BuyOperatorToken/actions";
import DashSearch from "components/DashSearch";
import { fetchSearch } from "containers/Dashboard/actions";
import { redirectDashboard } from "routes/RedirectRoutes";
import "./BuyOperatorToken.css";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useTheme } from "context/themeContext";
import DOMPurify from "dompurify";
import { useOperatorNavigate } from "utils/navigationHelper";
import ReservableCard from "components/Reservable card/ReservableCard";


const BuyOperatorToken = () => {
  const [page, setPage] = useState(0);
  const [pageSize] = useState(9);
  const [searchParams, setSearchParams] = useState({});
  const { colorTheme, logoUrl, whiteLabelName, canReserve,countryProperties } = useTheme();


  const navigate = useOperatorNavigate();
  const dispatch = useDispatch();

  const search = useSelector((state) => state.searchState.search || {});
  const loading = useSelector((state) => state.selectOperatorState.loading);
  const selectOperatorState = useSelector((state) => state.selectOperatorState);

  const loadData = (params = null) => {
    const currentParams = params || searchParams;
    if (params) {
      setSearchParams(params);
      setPage(0);
    }
    const wl = currentParams.whitelabel || whiteLabelName;
    dispatch(
      fetchSearch({
        ...currentParams,
        whitelabel: wl,
        page: params ? 0 : page,
        pageSize,
      })
    );
  };

  const handleSearch = (params) => {
    loadData(params);
  };

 
 

  const currentPage = page + 1;
  const totalPages = search?.totalPages || 1;

  const goToPage = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setPage(pageNumber - 1);
    const wl = searchParams.whitelabel || whiteLabelName;
    dispatch(
      fetchSearch({
        ...searchParams,
        whitelabel: wl,
        page: pageNumber - 1,
        pageSize,
      })
    );
  };
  
  

  const handler = (clickedValue) => {
    dispatch(setSelectedOp([]));
    setTimeout(() => {
      dispatch(setSelectedOp([clickedValue]));
     
      if (canReserve) {
        navigate("/reserve-seat-details");
      } else {
        navigate("/ticket-details");
      }
    }, 0);
  };
  

  // ✅ Non-reservable data lives in search.content
  const nonReservable =
    Array.isArray(search?.content) && search.content.length > 0
      ? search.content
          .filter((operator) => operator?.active !== false)
          .map((operators) => (
            <OperatorDataCard
              key={operators.id}
              operator={operators}
              operatorName={
                operators?.amount
                  ? new Intl.NumberFormat(countryProperties.locale, {
                      style: "currency",
                      currency: countryProperties.currency_code,
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(operators?.amount)
                  : null
              }
              routeType={operators?.routeClass?.name || ""}
              handler={handler}
              operatorMessage={
                operators?.name
                  ? operators?.name
                  : "Get up to 15% discounts on your return booking."
              }
            />
          ))
      : null;

  // ✅ Reservable data lives directly in search (not inside content)
  const reservable =
    search && Array.isArray(search)
      ? search.map((trip, idx) => (
          <ReservableCard key={idx} trip={trip} handler={handler} />
        ))
      : null;

  return (
    <div className="main-section">
      <div className="topBar">
        <img
          src={DOMPurify.sanitize(logoUrl)}
          alt={`${whiteLabelName} logo`}
          style={{
            width: "80px",
            height: "auto",
            objectFit: "fit",
            maxHeight: "80px",
          }}
        />
        <div
          onClick={redirectDashboard}
          style={{ color: colorTheme, cursor: "pointer" }}
        >
          Go Home
        </div>
      </div>

      <div className="dashboard_header_">
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <h4 className="header_title2" style={{ color: colorTheme }}>
            Select Route
          </h4>
        </div>
        <div style={{ display: "flex" }}>
          <button type="button" className="btn" onClick={redirectDashboard}>
            <span className="login-form__bold-text">Back</span>
          </button>
        </div>
      </div>

      <div className="search_container">
        <DashSearch
          searchState={handleSearch}
          selectOperatorState={selectOperatorState}
        />
      </div>

      <Container>
        {loading ? (
          <Loader />
        ) : (
          <div>
            <h1 className="search-r-title">Results</h1>

            {/* ✅ Reservable results */}
            {reservable && reservable.length > 0 && (
              <>
                
                <Row className="mt-4 operator-card__row">{reservable}</Row>
              </>
            )}

            {/* ✅ Non-reservable results */}
            {nonReservable && (
              <>
                
                <Row className="mt-4 operator-card__row">{nonReservable}</Row>
              </>
            )}

            {!reservable && !nonReservable && "No route found for this search"}

            {/* ✅ Pagination for non-reservable */}
            {nonReservable && (
              <div className="or_pagination">
                <button
                  onClick={() => goToPage(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  <LeftOutlined />
                </button>
                {[...Array(totalPages)].map((_, index) => (
                  <button
                    key={index + 1}
                    onClick={() => goToPage(index + 1)}
                    className={currentPage === index + 1 ? "active" : ""}
                  >
                    {index + 1}
                  </button>
                ))}
                <button
                  onClick={() => goToPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  <RightOutlined />
                </button>
              </div>
            )}
          </div>
        )}
      </Container>
    </div>
  );
};

export default BuyOperatorToken;
